<template>
	<div :class="computedClasses" class="tw-w-fit">
		<slot name="start-icon">
			<div v-if="startIcon" :class="svgClasses">
				<InlineSvg :src="loadFile(startIcon)" width="12px" height="12px" />
			</div>
		</slot>
		<slot>
			<div v-if="label">
				{{ label }}
			</div>
		</slot>
		<slot name="end-icon">
			<div v-if="endIcon" :class="svgClasses">
				<InlineSvg :src="loadFile(endIcon)" width="12px" height="12px" />
			</div>
		</slot>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import InlineSvg from './inline-svg';
import { loadFile } from '@/v2/utils/index';

const props = defineProps({
	label: {
		type: [String, Number],
		default: '',
	},
	size: {
		type: String,
		default: 'md',
	},
	variant: {
		type: String,
		default: 'brand',
	},
	modern: {
		type: Boolean,
		default: false,
	},
	circle: {
		type: Boolean,
		default: false,
	},
	startIcon: {
		type: String,
	},
	endIcon: {
		type: String,
	},
});

const svgClasses = computed(() => {
	const res = [];
	if (variantSvgClasses[props.variant]) {
		res.push(variantSvgClasses[props.variant]);
	} else {
		console.warn('[Badge]: variant not supported');
	}
	return res;
});
const computedClasses = computed(() => {
	const res = [];
	if (props.circle) {
		if (circleSizesClasses[props.size]) {
			res.push(circleSizesClasses[props.size]);
		} else {
			console.warn('[Badge]: size not supported');
		}
		res.push('tw-h-fit');
	} else {
		if (sizesClasses[props.size]) {
			res.push(sizesClasses[props.size]);
		} else {
			console.warn('[Badge]: size not supported');
		}
	}
	if (variantClasses[props.variant]) {
		res.push(variantClasses[props.variant]);
	} else {
		console.warn('[Badge]: variant not supported');
	}
	if (props.circle) {
		res.push('tw-rounded-full');
	} else if (props.modern) {
		res.push('tw-rounded-md');
	} else {
		res.push('tw-rounded-2xl');
	}
	res.push('tw-flex tw-items-center tw-gap-1');
	return res;
});

const sizesClasses = {
	sm: 'tw-px-2 tw-py-0.5',
	md: 'tw-px-2.5 tw-py-0.5',
	lg: 'tw-px-3 tw-py-1',
};

const circleSizesClasses = {
	sm: 'tw-p-[5px]',
	md: 'tw-p-1.5',
	lg: 'tw-p-2',
};

const variantClasses = {
	gray: 'tw-text-gray-700 tw-bg-gray-50 tw-border tw-border-gray-200',
	brand: 'tw-text-brand-700 tw-bg-brand-50 tw-border tw-border-brand-200',
	error: 'tw-text-error-700 tw-bg-error-50 tw-border tw-border-error-200',
	warning: 'tw-text-warning-700 tw-bg-warning-50 tw-border tw-border-warning-200',
	success: 'tw-text-success-700 tw-bg-success-50 tw-border tw-border-success-200',
	blue: 'tw-text-blue-700 tw-bg-blue-50 tw-border tw-border-blue-200',
	indigo: 'tw-text-indigo-700 tw-bg-indigo-50 tw-border tw-border-indigo-200',
	orange: 'tw-text-orange-700 tw-bg-orange-50 tw-border tw-border-orange-200',
};
const variantSvgClasses = {
	gray: 'tw-text-gray-500',
	brand: 'tw-text-brand-500',
	error: 'tw-text-error-500',
	warning: 'tw-text-warning-500',
	success: 'tw-text-success-500',
	blue: 'tw-text-blue-500',
	indigo: 'tw-text-indigo-500',
	orange: 'tw-text-orange-500',
};
</script>

<style lang="scss" scoped></style>
